import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPicklebet = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40.733948 37.45262",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.6013 0.40189C19.1161 0.140005 17.6113 0.00555176 16.1034 0C10.7059 0 6.1585 1.83334 3.23486 5.15685C0.725709 8.04949 -0.406964 11.8943 0.131302 15.6918C1.07586 23.2871 8.86175 37.4526 20.3719 37.4526C31.4143 37.4526 40.7339 24.0141 40.7339 15.5699C40.7429 8.13716 33.4023 2.59648 20.6013 0.40189L20.6013 0.40189ZM26.3946 31.6816C22.378 34.0117 18.4018 34.0207 14.5696 31.6816C12.613 30.4477 10.8905 28.8744 9.48246 27.0351C6.67577 23.5129 4.57075 18.8528 4.11646 15.1951C3.93291 13.8341 4.03557 12.4497 4.41782 11.131C4.78083 9.91076 5.40396 8.78439 6.24398 7.8301C8.39397 5.38715 11.8888 4.04149 16.0899 4.04149C17.376 4.04584 18.6595 4.15913 19.9266 4.38016C25.1172 5.28329 29.4172 6.79151 32.3633 8.76032C33.6723 9.5852 34.7965 10.6738 35.6648 11.9574L35.6648 11.9574C36.3618 13.0317 36.7294 14.2878 36.7218 15.5699C36.6454 17.429 36.21 19.2555 35.4399 20.948C34.5008 23.1376 33.2526 25.1801 31.7336 27.0125C30.2382 28.869 28.4314 30.4491 26.3946 31.6816L26.3946 31.6816Z",
			fill: "#57D33B",
			fillRule: "evenodd",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.6749 11.6277C22.6753 10.5967 22.0564 9.66617 21.1069 9.27094C20.1574 8.87571 19.0643 9.09362 18.3372 9.82304C17.6102 10.5525 17.3924 11.6498 17.7854 12.6033C18.1784 13.5568 19.1048 14.1787 20.1327 14.1791C20.8069 14.1793 21.4535 13.9106 21.9303 13.4321C22.407 12.9536 22.6749 12.3045 22.6749 11.6277L22.6749 11.6277Z",
			fill: "#57D33B",
			fillRule: "evenodd",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5381 16.1705C11.5381 14.7614 12.6758 13.6191 14.0794 13.6191C15.4829 13.6191 16.6207 14.7614 16.6207 16.1705C16.6207 17.5795 15.4829 18.7218 14.0794 18.7218C12.6758 18.7218 11.5381 17.5795 11.5381 16.1705Z",
			fill: "#57D33B",
			fillRule: "evenodd",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.6465 16.1705C23.6465 14.7614 24.7842 13.6191 26.1878 13.6191C27.5913 13.6191 28.7291 14.7614 28.7291 16.1705C28.7291 17.5795 27.5913 18.7218 26.1878 18.7218C24.7842 18.7218 23.6465 17.5795 23.6465 16.1705Z",
			fill: "#57D33B",
			fillRule: "evenodd",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.9028 20.659C22.875 20.659 21.9483 21.2806 21.5549 22.234C21.1616 23.1873 21.379 24.2847 22.1058 25.0144C22.8326 25.744 23.9257 25.9623 24.8753 25.5674C25.825 25.1726 26.4441 24.2422 26.4441 23.2103C26.4441 21.8012 25.3063 20.659 23.9028 20.659L23.9028 20.659Z",
			fill: "#57D33B",
			fillRule: "evenodd",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.3643 20.659C14.9608 20.659 13.823 21.8013 13.823 23.2103C13.823 24.6194 14.9608 25.7617 16.3643 25.7617C17.7678 25.7617 18.9056 24.6194 18.9056 23.2103C18.9061 21.8021 17.7687 20.6595 16.3652 20.659L16.3643 20.659Z",
			fill: "#57D33B",
			fillRule: "evenodd",
			stroke: "none"
		})
	] })
});
export { SvgIconPicklebet as ReactComponent };
